import type {Pointer, PS} from '@wix/document-services-types'
import _ from 'lodash'
import documentModeInfo from '../../documentMode/documentModeInfo'
import metaDataUtils from '../metaDataUtils'
import dataModel from '../../dataModel/dataModel'

function getWidgetData(ps: PS, compData) {
    if (!_.has(compData, 'applicationId') || !_.has(compData, 'widgetId')) {
        return {}
    }
    const clientSpecMapPtr = ps.pointers.general.getClientSpecMap()
    const csm = ps.dal.getNoClone(clientSpecMapPtr)
    const result = _.get(csm, [compData.applicationId, 'widgets', compData.widgetId]) || {}
    return _.cloneDeep(result)
}

const getFromStageData = (ps: PS, compRef: Pointer, stageDataKey: string, defaultValue) =>
    metaDataUtils.getFromStageData(ps, stageDataKey, compRef, defaultValue)

export default {
    getWidgetData,
    rotatable(ps: PS, compRef: Pointer) {
        return getFromStageData(ps, compRef, 'rotatable', false)
    },
    canBeFixedPosition(ps: PS, compRef: Pointer) {
        return getFromStageData(ps, compRef, 'pinnable', true)
    },
    removable(ps: PS, compRef: Pointer) {
        const compData = dataModel.getDataItem(ps, compRef)
        const appDefinitionId = _.get(compData, 'appDefinitionId')
        const installedWidgets = ps.extensionAPI.tpa.getWidgetsByAppDefId(appDefinitionId)

        if (
            compRef.type === 'MOBILE' &&
            ps.extensionAPI.tpa.isLastInstalledMainWidget(installedWidgets, appDefinitionId, compRef) &&
            ps.extensionAPI.tpa.isAppActive(appDefinitionId)
        ) {
            return false
        }
        return getFromStageData(ps, compRef, 'removable', true)
    },
    duplicatable(ps: PS, compRef: Pointer) {
        return getFromStageData(ps, compRef, 'duplicatable', !documentModeInfo.isMobileView(ps))
    },
    resizable(ps: PS, compRef: Pointer) {
        return getFromStageData(ps, compRef, 'resizable', true)
    },
    canReparent(ps: PS, compRef: Pointer) {
        return getFromStageData(ps, compRef, 'canReparent', true)
    }
}
